import { useTranslation } from 'react-i18next';

const icons = [
  'ri-shield-check-line',
  'ri-bar-chart-box-line',
  'ri-bank-card-2-line',
  'ri-user-star-line',
  'ri-building-2-line',
  'ri-percent-line',
];

export default function WhyLLCSection() {
  const { t } = useTranslation();

  const cards = [1, 2, 3, 4, 5, 6].map((n) => ({
    icon: icons[n - 1],
    title: t(`sllc_why_card_${n}_title`),
    desc: t(`sllc_why_card_${n}_desc`),
  }));

  return (
    <section className="py-24 bg-[#F8F3FB]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-[#4F2D63] text-sm font-semibold uppercase tracking-widest">
            {t('sllc_why_eyebrow')}
          </span>
          <h2 className="mt-3 text-3xl lg:text-4xl font-bold text-gray-900">
            {t('sllc_why_title')}
          </h2>
          <p className="mt-4 text-gray-600 text-base leading-relaxed">
            {t('sllc_why_subtitle')}
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {cards.map((card) => (
            <div
              key={card.title}
              className="bg-white rounded-lg border border-[#E9D9F2] p-7 flex flex-col gap-4"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-[#F8F3FB] border border-[#E9D9F2]">
                <i className={`${card.icon} text-[#4F2D63] text-xl`} />
              </div>
              <h3 className="text-base font-bold text-gray-900 leading-snug">{card.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{card.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
